<template lang="pug">
  div.body.body-table.technology-table
    div.table-choose-panel
      div.toolbar-table
        div.select Применяемые технологии

        div.toolbar.toolbar--modal
          div.line
            div.parameters

            div.actions-panel
              e-button-add(
              @click="addNewRowToTable()"
              v-if="!editDisabled"
              )
              //button(v-if="role!=='guest'" type="button" @click="addNewRowToMedicalTable()").actions-panel__button.btn-add.green

      div
        e-table-editable(
        ref="detail"
        :attributes="detailAttr"
        :dataUrl="dataUrl"
        :postUrl="postUrl"
        :patchUrl="patchUrl"
        :deleteUrl="deleteUrl"
        :tableInOnlineMode="tableInOnlineMode"
        :afterFetchData="afterFetchData"
        :afterValidate="afterValidate"
        )
  //:enabledActions="enabledActions"
</template>

<script>
  import {cadastr, tko} from '../../../api/api-endpoints.js'
  import {tkoOffline} from '../../../api/api-offline-endpoints.js'
  import {PERMS} from '../../../config/permissions.js'

  export default {
    name: 'technology-table',
    props: {
      id: null,
      itemId: null,
      tabView: null,
      formDisabled: {
        type: Boolean,
        default: false
      },
      fields: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data () {
      return {
        openSelect: false
      }
    },
    computed: {
      tableInOnlineMode () {
        return this.itemId
      },
      enabledActions () {
        if (this.formDisabled) {
          return []
        } else {
          return [PERMS.EDIT, PERMS.CREATE, PERMS.DELETE]
        }
      },
      editDisabled () {
        return this.formDisabled
      },
      detailAttr () {
        return {
          name: {
            label: 'Технология',
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название',
            required: true,
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          tko_action: {
            disabled: true,
            width: 200,
            label: 'Вид деятельности',
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          },
          tech_target: {
            label: 'Назначение',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          start_year: {
            label: 'Год начала применения',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          end_year: {
            label: 'Год окончания применения',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          has_project: {
            label: 'Наличие проектной документации',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          has_expertise: {
            label: 'Заключение экологической экспертизы',
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          power_tons: {
            label: 'Мощность',
            disabled: true,
            placeholder: ' ',
            validationRulePattern: '(\\.*)'
          }
        }
      },
      dataUrl () {
        if (this.id) {
          return tko.objectTechOperation(this.id)
        }
        // if new record, offline save
        return tkoOffline.objectTechTable(this.$route.name)
      }
    },
    methods: {
      afterValidate (ctx, model, errors, els) {
        if (model.name && model.name.length > 1 && !model.tech_id) {
          errors.name = 'Выберите технологию из списка'
        }
        if (model.tech_id) {
          let items = ctx.data.data || []
          for (let techIndex = 0; techIndex < items.length; techIndex++) {
            let tech = items[techIndex]
            let techRowId = tech.id || tech._storeUUID
            let modelId = model.id || model._storeUUID
            console.log('tech', techRowId, modelId, tech)
            if (techRowId != modelId && model.tech_id == tech.tech_id) {
              errors.name = 'Данная технология уже была добавлена'
              // TODO: fix bug in table editable component
              ctx.openEditMode(model)
              setTimeout(() => {
                ctx.openEditMode(model)
              }, 0)
            }
          }
        }
        return errors
      },
      transformTechTarget (model) {
        if (model.techTarget) {
          return model.techTarget.name
        }
        return ''
      },
      transformBoolean (model, name = 'has_project') {
        return model[name] ? 'Да' : 'Нет'
      },
      transformActions (model) {
        console.log('--', model)
        let actions = []
        if (model.tkoActions && Array.isArray(model.tkoActions)) {
          model.tkoActions.forEach(v => {
            actions.push(v.name)
          })
        }
        return actions.join(',')
      },
      onSelect (ctx, $event, model, attr) {
        if ($event && $event.id) {
          // for set data with call setters
          for (let key in $event) {
            // fix: for prevent post reponse on create
            if (key !== 'id') {
              model[key] = $event[key]
            }
          }
          model.tech_id = $event.id
          model._storeUUID = +new Date()
          model.tko_action = this.transformActions($event)
          model.has_project = this.transformBoolean($event, 'has_project')
          model.has_expertise = this.transformBoolean($event, 'has_expertise')
          model.tech_target = this.transformTechTarget($event)
          console.log('---onSelect---', model)
        } else {
          model.tech_id = ''
          model.name = ''
        }
      },
      suggestionEndpoint (ctx, q) {
        return cadastr.techs({query: {q: q, 'per-page': 50}})
      },
      transformSuggestions (ctx, response) {
        return response.data
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          // data.data[i].tko_action = this.transformActions(data.data[i])
          data.data[i].has_project = this.transformBoolean(data.data[i], 'has_project')
          data.data[i].has_expertise = this.transformBoolean(data.data[i], 'has_expertise')
          // data.data[i].tech_target = this.transformTechTarget(data.data[i])
        }
        return data
      },
      postUrl (context, model) {
        return tko.objectTechOperationPost(this.id)
      },
      patchUrl (context, model) {
        return tko.objectTechOperationPatch(model.id)
      },
      deleteUrl (context, model) {
        return tko.objectTechOperationDelete(model.id)
      },
      addNewRowToTable () {
        const Model = () => {
          return {
            id: '',
            name: '',
            tkoActionsName: '',
            has_project: '',
            has_expertise: '',
            techTargetName: ''
          }
        }
        this.$refs.detail.createRow(new Model())
      }
    }
  }
</script>
